import { Link } from 'react-router-dom';
import { Head } from 'vite-react-ssg';

export default function NotFound() {
  return (
    <>
      <Head>
        <title>Page Not Found — Revive Builders LLC</title>
        <meta name="robots" content="noindex" />
      </Head>
      <section className="flex min-h-[70vh] flex-col items-center justify-center bg-ink-950 px-6 pt-24 text-center">
        <p className="eyebrow mb-6">404</p>
        <h1 className="font-display text-5xl font-medium text-steel-100 md:text-6xl">
          This page doesn't <span className="italic text-gold-300">exist.</span>
        </h1>
        <p className="mt-6 max-w-md text-base font-light text-steel-300">
          The page you're looking for was moved or never built. Head back home, or tell us about your project.
        </p>
        <div className="mt-10 flex gap-4">
          <Link
            to="/"
            className="border border-gold-500/40 px-8 py-3.5 text-xs uppercase tracking-[0.25em] text-gold-300 transition-all duration-300 hover:bg-gold-500 hover:text-ink-950"
          >
            Back Home
          </Link>
          <Link
            to="/contact"
            className="bg-gold-500 px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.25em] text-ink-950 transition-all duration-500 hover:bg-gold-400"
          >
            Request a Bid
          </Link>
        </div>
      </section>
    </>
  );
}
